/* SETGK — Secret Menu behavior: intro decrypt, glitch text setup, countdown. */
(function () {
  function setGlitchAttrs(root) {
    root.querySelectorAll('.sm-glitch').forEach(function (el) {
      if (!el.hasAttribute('data-sm-glitch')) {
        el.setAttribute('data-sm-glitch', el.textContent.trim());
      }
    });
  }

  function runIntro(root) {
    var intro = root.querySelector('.sm-intro');
    function reveal() {
      root.dispatchEvent(new CustomEvent('sm:decrypted'));
    }

    if (!intro) { reveal(); return; }

    var seenKey = 'sm_seen_' + (root.getAttribute('data-sm-key') || 'default');
    var skip = false;
    try { skip = sessionStorage.getItem(seenKey) === '1'; } catch (e) { skip = false; }

    if (skip) {
      intro.setAttribute('hidden', '');
      reveal();
      return;
    }

    var lines = intro.querySelectorAll('[data-sm-intro-line]');
    var delay = 0;
    lines.forEach(function (line, i) {
      line.style.opacity = '0';
      setTimeout(function () {
        line.style.transition = 'opacity 0.25s ease';
        line.style.opacity = '1';
      }, delay);
      delay += 260;
    });

    setTimeout(function () {
      intro.classList.add('sm-intro--out');
      setTimeout(function () { intro.setAttribute('hidden', ''); }, 550);
      try { sessionStorage.setItem(seenKey, '1'); } catch (e) {}
      reveal();
    }, delay + 500);
  }

  function initQcStamp(root) {
    var stamp = root.querySelector('[data-sm-stamp]');
    if (!stamp) return;
    root.addEventListener('sm:decrypted', function () {
      setTimeout(function () { stamp.classList.add('sm-stamp--show'); }, 300);
    }, { once: true });
  }

  function initTerminal(root) {
    var script = root.querySelector('[data-sm-terminal-lines]');
    var output = root.querySelector('[data-sm-terminal-output]');
    if (!script || !output) return;

    var lines = [];
    try { lines = JSON.parse(script.textContent); } catch (e) { lines = []; }
    lines = lines.filter(function (l) { return l && l.replace(/\s/g, '').length; });
    if (!lines.length) return;

    function typeLine(index) {
      if (index >= lines.length) {
        setTimeout(function () {
          output.innerHTML = '';
          typeLine(0);
        }, 4000);
        return;
      }
      var line = lines[index];
      var row = document.createElement('div');
      row.className = 'sm-terminal__line';
      output.appendChild(row);
      var i = 0;
      var iv = setInterval(function () {
        row.textContent = line.slice(0, i + 1);
        i++;
        if (i >= line.length) {
          clearInterval(iv);
          output.scrollTop = output.scrollHeight;
          setTimeout(function () { typeLine(index + 1); }, 500);
        }
      }, 18);
    }

    root.addEventListener('sm:decrypted', function () { typeLine(0); }, { once: true });
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-sm-sticky-bar]');
    var mainBtn = root.querySelector('[data-sm-main-claim]');
    var stickyBtn = root.querySelector('[data-sm-sticky-claim]');
    if (!bar || !mainBtn) return;

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { mainBtn.click(); });
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sm-sticky-bar--show', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      obs.observe(mainBtn);
    }
  }

  function initDiagBars(root) {
    var bars = root.querySelectorAll('[data-sm-diag-fill]');
    if (!bars.length) return;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            el.style.width = el.getAttribute('data-sm-diag-fill') + '%';
            obs.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      bars.forEach(function (b) { b.style.width = '0%'; obs.observe(b); });
    } else {
      bars.forEach(function (b) { b.style.width = b.getAttribute('data-sm-diag-fill') + '%'; });
    }
  }

  function initGridReveal(root) {
    var grid = root.querySelector('[data-sm-grid]');
    if (!grid) return;
    var cards = grid.querySelectorAll('.sm-card');
    if (!cards.length) return;

    cards.forEach(function (card) { card.classList.add('sm-card--pending'); });

    function reveal() {
      cards.forEach(function (card, i) {
        setTimeout(function () {
          card.classList.remove('sm-card--pending');
        }, i * 90);
      });
    }

    root.addEventListener('sm:decrypted', reveal, { once: true });
  }

  function initGripIndex(root) {
    var el = root.querySelector('[data-sm-grip]');
    if (!el) return;
    var target = parseFloat(el.getAttribute('data-sm-grip')) || 0;
    var fill = el.querySelector('[data-sm-grip-fill]');
    var valueEl = el.querySelector('[data-sm-grip-value]');
    if (!fill || !valueEl) return;

    function colorClass(v) {
      if (v >= 90) return 'sm-grip__fill--high';
      if (v >= 70) return 'sm-grip__fill--mid';
      return '';
    }

    function animate() {
      fill.style.width = target + '%';
      var cls = colorClass(target);
      if (cls) fill.classList.add(cls);

      var start = null;
      var duration = 1100;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        valueEl.textContent = Math.round(eased * target);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          valueEl.textContent = Math.round(target);
        }
      }
      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate();
            obs.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      obs.observe(el);
    } else {
      animate();
    }
  }

  function runCountdown(root) {
    var el = root.querySelector('[data-sm-countdown]');
    if (!el) return;
    var endAttr = el.getAttribute('data-sm-countdown');
    var end = new Date(endAttr).getTime();
    if (isNaN(end)) { el.hidden = true; return; }

    var dEl = el.querySelector('[data-sm-d]');
    var hEl = el.querySelector('[data-sm-h]');
    var mEl = el.querySelector('[data-sm-m]');
    var sEl = el.querySelector('[data-sm-s]');

    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) {
        el.hidden = true;
        var ended = root.querySelector('[data-sm-ended]');
        if (ended) ended.hidden = false;
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = String(d).padStart(2, '0');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  function initThumbs(root) {
    var main = root.querySelector('[data-sm-main-img]');
    if (!main) return;
    root.querySelectorAll('[data-sm-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-sm-thumb');
        if (src) main.setAttribute('src', src);
        root.querySelectorAll('[data-sm-thumb]').forEach(function (b) { b.classList.remove('sm-thumb--active'); });
        btn.classList.add('sm-thumb--active');
      });
    });
  }

  function initScope(root) {
    setGlitchAttrs(root);
    runCountdown(root);
    initThumbs(root);
    initQcStamp(root);
    initTerminal(root);
    initStickyBar(root);
    initDiagBars(root);
    initGripIndex(root);
    initGridReveal(root);
    // runIntro fires the 'sm:decrypted' event — sometimes synchronously, when the
    // intro has already been seen this session (e.g. navigating back to a collection
    // page). It must run LAST so every listener above is already attached before that
    // event can fire; otherwise their 'sm:decrypted' handlers never run and elements
    // (grid cards, QC stamp, terminal) get stuck in their initial hidden/pending state.
    runIntro(root);
  }

  document.querySelectorAll('.sm-scope').forEach(initScope);
})();
